import { Fragment } from 'react';
import TablePaginate from '../../components/Paginate';
import usePaginateDefaults from 'hooks/usePaginateDefaults';
import useRegisterRequests from 'hooks/API/GET/useRegisterRequests';

function ManageUser() {
  const [params, setParams] = usePaginateDefaults();

  const _data = useRegisterRequests({
    enabled: true,
  });
  const { isLoading, data: tableData, isError } = _data;
  const { meta: { page, total } = {} } = tableData?.data ?? {};

  return (
    <Fragment>
      <div className="mainWraper">
        <div className="container-fluid outerborder">
          <div className="row">
            <div className="col-6">
              <h2 className="prime-head p-0">Email requests</h2>
            </div>
          </div>

          <div className="tableWrap">
            <div className="table-responsive">
              <table className="table tableWrap__table">
                <thead className="thead-light __appTheadColor">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Email</th>
                  </tr>
                </thead>
                {isLoading ? (
                  'Loading...'
                ) : isError ? (
                  'Failed to load data'
                ) : tableData?.data?.result?.length > 0 ? (
                  <tbody>
                    {tableData?.data?.result?.map((result, index) => {
                      return (
                        <Fragment>
                          <tr key={result._id}>
                            <th scope="row">{index + 1}</th>
                            <td>{result.email}</td>
                          </tr>
                        </Fragment>
                      );
                    })}
                  </tbody>
                ) : (
                  'No records found'
                )}
              </table>
            </div>
          </div>
          <TablePaginate
            maxCount={total}
            currentPage={page}
            defaultLimit={params.limit}
            setPage={(page) => setParams((x) => ({ ...x, page }))}
            handleChange={(limit) => setParams((x) => ({ ...x, limit }))}
          />
        </div>
      </div>
    </Fragment>
  );
}

export default ManageUser;
